import React, { useCallback, useEffect, useState } from 'react'
import { Label } from 'components/Form'
import { UploadFileStyles, WrapUploadFileButton, Label as Text, WrapHeaderUpload, WrapAudioContent, WrapFieldContent, WrapField, VisuallyHiddenInput, WrapAudio } from './Styled'
import { Cancel, Close, Delete } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import { Img } from 'styles/GlobalStyle';
import { useMutation } from '@tanstack/react-query';
import { removeFileFetch, uploadImageFileFetch } from 'store/middlewares/newsletter.crud';
import Error from './Error'

const ImageUploaded = ({ file, cleanFile }) => (
    <div className='image-and-remove'>
        <div className='remove-button' onClick={cleanFile}>
            <Cancel className='remove-icon' />
        </div>
        <div className='image-preview'>
            <Img src={file.url || file.preview || file} alt="Uploaded" />
        </div>
    </div>
)

const AudioUploaded = ({ file }) => (
    <WrapAudio controls>
        <source src={URL.createObjectURL(file)} type="audio/mpeg" />
        Your browser does not support the audio element.
    </WrapAudio>
)

const UploadFile = (props) => {
    const { type, name, label, input = {}, showCleanIcon, section, className, mandatory } = props,
        { onChange, value } = input;

    const { mutateAsync: removeFile } = useMutation({
        mutationFn: removeFileFetch,
        mutationKey: "upload-file",
        onSuccess: () => {
            cleanFile()
        }
    })

    const handleChangeAudio = useCallback(e => {
        const file = e.target.files[0];
        onChange(file)
    }, [])

    const handleChangeImage = useCallback(e => {
        const nFile = e.target.files[0];
        const reader = new FileReader();

        reader.onloadend = async () => {
            onChange({ preview: reader.result, file: nFile })
        };

        if (nFile) {
            reader.readAsDataURL(nFile);
        }
    }, [])

    const cleanFile = useCallback(() => {
        onChange(null)
    }, [])

    const removeImage = useCallback(() => {
        removeFile(value.file_name)
    }, [value])

    const item = {
        "image": {
            accept: "image/*",
            component: ImageUploaded,
            handleChange: handleChangeImage,
            boxHeight: 150,
            cleanFile: cleanFile,
            acceptMessage: "העלה קובץ מסוג תמונה"
        },
        "audio": {
            accept: "audio/*",
            component: AudioUploaded,
            handleChange: handleChangeAudio,
            boxHeight: 50,
            cleanFile: cleanFile
        },
        "exel": {
            accept: ".xls,.xlsx",
            component: () => null,
            handleChange: handleChangeAudio,
            boxHeight: 50,
            cleanFile: cleanFile
        }
    }

    const UploadedComponent = item[type].component

    return (
        <WrapField className={className} section={section}>
            <UploadFileStyles>
                <WrapFieldContent>
                    {label && <Label label={label} mandatory={mandatory} />}

                    {value &&
                        <WrapHeaderUpload>
                            <Text>{value?.name}</Text>
                            {showCleanIcon &&
                                <IconButton size='small' onClick={cleanFile}>
                                    <Close fontSize='small' />
                                </IconButton>}
                        </WrapHeaderUpload>
                    }
                    <WrapAudioContent>
                        {value ?
                            <UploadedComponent file={value} cleanFile={item[type].cleanFile} />
                            :
                            <WrapUploadFileButton
                                color="thirdly"
                                component="label"
                                role={undefined}
                                tabIndex={-1}
                                boxHeight={item[type].boxHeight}
                            >
                                <VisuallyHiddenInput
                                    type="file"
                                    name={name}
                                    onChange={item[type].handleChange}
                                    accept={item[type].accept}
                                />
                                <div className='upload-file-message'>
                                    <div className='upload-message'>
                                        {"להקליק לבחירת קובץ"}
                                    </div>
                                    <div>
                                        {item[type].acceptMessage}
                                    </div>
                                </div>
                            </WrapUploadFileButton>
                        }
                    </WrapAudioContent>
                </WrapFieldContent>
            </UploadFileStyles>
            <Error {...props} />
        </WrapField>
    )
}

export default UploadFile